import { createAction } from '@/utility/actions';

import {
  AUTH_LOGOUT,
  AUTH_LOGIN,
  AUTH_AUTH0_LOGIN,
  AUTH_LOGIN_AS,
  AUTH_REGISTER_USER,
  AUTH_CREATE_PASSWORD,
  AUTH_RP_UPDATE,
  AUTH_RP_SEND_EMAIL,
  AUTH_SET_ANONYMOUS_ID,
} from './_types.ts';

/**
 * Login
 * @param {object} data
 * @returns {{types: *, action: *}}
 */
export const login = createAction(AUTH_LOGIN);

/**
 * Login with auth0 callback
 * @param {object} data
 * @returns {{types: *, action: *}}
 */
export const loginWithAuth0 = createAction(AUTH_AUTH0_LOGIN);

export const loginAs = createAction(AUTH_LOGIN_AS);

/**
 * * User Registration
 * @param {object} data
 * @returns {{types: *, action: *}}
 */
export const registerUser = createAction(AUTH_REGISTER_USER);

/**
 * * Send reset password email
 * @param {object} email
 */
export const resetPasswordSendEmail = createAction(AUTH_RP_SEND_EMAIL);

/**
 * * Update password
 * @param {object} data
 */
export const resetPassUpdate = createAction(AUTH_RP_UPDATE);

/**
 * * Create password
 * @param {object} data
 */
export const createPassword = createAction(AUTH_CREATE_PASSWORD);

export const logout = createAction(AUTH_LOGOUT);

/**
 * setAnonymousId - id
 */
export const setAnonymousId = createAction(AUTH_SET_ANONYMOUS_ID);

export default {
  login,
  loginAs,
  loginWithAuth0,
  registerUser,
  resetPasswordSendEmail,
  resetPassUpdate,
  createPassword,
  logout,
  setAnonymousId,
};
